function bannerVideoSetFullScreenData(state) {
  $(".bannerVideo").attr("data-fullscreen", !!state);
}

document.addEventListener("fullscreenchange", function (e) {
  bannerVideoSetFullScreenData(
    document.fullScreen || document.fullscreenElement
  );
});

document.addEventListener("webkitfullscreenchange", function () {
  bannerVideoSetFullScreenData(document.webkitIsFullScreen);
});

document.addEventListener("mozfullscreenchange", function () {
  bannerVideoSetFullScreenData(document.mozFullScreen);
});

document.addEventListener("msfullscreenchange", function () {
  bannerVideoSetFullScreenData(document.msFullscreenElement);
});

function bannerVideoToggleFullscreen() {
  var video = $(".bannerVideo").get(0);
  var fullScreen =
    document.fullScreen ||
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement ||
    document.fullscreenElement ||
    video.webkitDisplayingFullscreen;
  if (fullScreen) {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
    else if (video.webkitExitFullScreen) video.webkitExitFullScreen();
  } else {
    if (video) {
      if (video.requestFullscreen) video.requestFullscreen();
      else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
      else if (video.webkitRequestFullScreen) video.webkitRequestFullScreen();
      else if (video.msRequestFullscreen) video.msRequestFullscreen();
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    }
  }
  bannerVideoSetFullScreenData(!fullScreen);
}

function bannerVideoSetPaused(paused) {
  if (paused) {
    $(".bannerVideoPlayPause").addClass("paused");
  } else {
    $(".bannerVideoPlayPause").removeClass("paused");
  }
}

function bannerVideoSetMuted(muted) {
  if (muted) {
    $(".bannerVideoMuteUnmute").addClass("muted");
  } else {
    $(".bannerVideoMuteUnmute").removeClass("muted");
  }
}

function bannerVideoTogglePlay() {
  var video = $(".bannerVideo").get(0);
  if (!video) {
    return;
  }
  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
}

function bannerVideoToggleMute() {
  var video = $(".bannerVideo").get(0);
  if (!video) {
    return;
  }
  video.muted = !video.muted;
}

document.addEventListener("DOMContentLoaded", function (event) {
  var video = $(".bannerVideo").get(0);
  if (!video) {
    return;
  }
  bannerVideoSetPaused(video.paused);
  video.addEventListener("pause", function () {
    bannerVideoSetPaused(true);
  });
  video.addEventListener("playing", function () {
    bannerVideoSetPaused(false);
  });

  bannerVideoSetMuted(video.muted);
  video.addEventListener("volumechange", function () {
    bannerVideoSetMuted(video.muted);
  });

  video.addEventListener("loadedmetadata", function () {
    var fullScreenEnabled = !!(
      document.fullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled ||
      document.webkitSupportsFullscreen ||
      document.webkitFullscreenEnabled ||
      video.webkitRequestFullScreen ||
      video.webkitEnterFullscreen
    );

    if (fullScreenEnabled) {
      $(".bannerVideoExpand").show();
    }
  });
});
